export default __webpack_public_path__ + "static/media/8.46880ff9.jpg";